import React from "react";
import { Grid } from "@mui/material";
import TableInc from "../../../../shared-ui/TableInc";
import ButtonInc from "../../../../shared-ui/ButtonInc";
import SkeletonWrapper from "../../../../components/SkeletonWrapper/SkeletonWrapper";

export default function ViewPolicyMakerChecks(props) {
  var isLoading = props.isLoading;
  var checks = props.policyMakerChecks || [];
  var onAddCheck = props.onAddCheck;
  var onEditCheck = props.onEditCheck;
  var onDeleteCheck = props.onDeleteCheck;

  if (isLoading) {
    return <SkeletonWrapper loading={true} />;
  }

  var sortedChecks = checks.slice().sort(function(a, b) {
    return (a.sequence || 0) - (b.sequence || 0);
  });

  return (
    <div style={{ marginTop: "3%" }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        style={{ marginBottom: 12 }}
      >
        <Grid item>
          <h3 style={{ margin: 0 }}>Policy Maker-Checker Sequence</h3>
        </Grid>
        <Grid item>
          <ButtonInc variant="contained" color="primary" onClick={onAddCheck}>
            + Add Check
          </ButtonInc>
        </Grid>
      </Grid>

      <TableInc
        columns={[
          {
            title: "Sequence",
            field: "sequence",
            render: function(row) {
              return row.sequence != null ? "#" + row.sequence : "—";
            },
          },
          {
            title: "Type",
            field: "type",
            render: function(row) {
              return row.type || "—";
            },
          },
          {
            title: "Label",
            field: "label",
            render: function(row) {
              return row.label || "(no label)";
            },
          },
          {
            title: "Skippable",
            field: "allow_to_skip",
            render: function(row) {
              return row.allow_to_skip ? "Yes" : "No";
            },
          },
        ]}
        data={sortedChecks}
        actions={[
          {
            icon: "edit",
            tooltip: "Edit check",
            onClick: function(e, row) {
              onEditCheck(row);
            },
          },
          {
            icon: "delete",
            tooltip: "Delete check",
            onClick: function(e, row) {
              onDeleteCheck(row);
            },
          },
        ]}
        options={{
          showTitle: false,
          actionsColumnIndex: -1,
          pageSize: 5,
          search: false,
          emptyRowsWhenPaging: false,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: "No policy maker checks configured yet.",
          },
        }}
      />
      <br />
    </div>
  );
}
